import ProductModel from "./ProductModel";

export default function ProductSection() {
  return (
    <>
      <ProductModel
        projectName="Infini Loops"
        modelPath="./models/product/infiniLoops.glb"
        position={[-25, 0, -15]}
        scale={1}
        rotation={[0, Math.PI / 8, 0]}
      />
    </>
  );
}
